import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { StyledDialogTitle } from 'components/TooltipDialog/style';
import { ShortBody } from 'components/Typography';

export interface DialogTitleProps {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

const DialogTitle = (props: DialogTitleProps) => {
  const { children, onClose, ...other } = props;
  return (
    <StyledDialogTitle disableTypography {...other}>
      <ShortBody>{children}</ShortBody>
      <IconButton aria-label="close" onClick={onClose}>
        <CloseIcon />
      </IconButton>
    </StyledDialogTitle>
  );
};

interface ITooltipDialog {
  open: boolean;
  handleClose: () => void;
  title: string;
  description: string;
}

export default function TooltipDialog({
  open,
  handleClose,
  title,
  description,
}: ITooltipDialog) {
  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
        {title}
      </DialogTitle>
      <MuiDialogContent dividers>
        <ShortBody>{description}</ShortBody>
      </MuiDialogContent>
    </Dialog>
  );
}
